import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

var firebaseConfig = {
    apiKey: "AIzaSyA6sVGCmLSHLNKTrI5QbVYhVO5d4SQ2gkc",
    authDomain: "anton-chat-c744e.firebaseapp.com",
    databaseURL: "https://anton-chat-c744e.firebaseio.com",
    projectId: "anton-chat-c744e",
    storageBucket: "anton-chat-c744e.appspot.com",
    messagingSenderId: "72177748811",
    appId: "1:72177748811:web:e86fb8bf6dbd24107176ce",
    measurementId: "G-5NNKSXXYX6"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js